import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DashBoardInfos } from '@classes/dashboard/dashboard';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashbordService {

  constructor(private http: HttpClient) { }

  /* ----------------------------------- GET ---------------------------------- */
  getInfosDashboard(id: string, dateStart: string, dateEnd: string): Observable<DashBoardInfos[]> {
    return this.http.get<DashBoardInfos[]>(`${environment.apiUrl}/dashboard`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` },
      params: {
        cameraId: id, from: dateStart, to: dateEnd
      }
    });
  }

  getInfosCarSuction(id: string, dateStart: string, dateEnd: string): Observable<DashBoardInfos> {
    return this.http.get<DashBoardInfos>(`${environment.apiUrl}/dashboard/CarSuctionCup`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` },
      params: {
        cameraId: id, from: dateStart, to: dateEnd
      },
    });
  }

  getInfosCarSuctionToday(id: string): Observable<number> {
    return this.http.get<number>(`${environment.apiUrl}/dashboard/CarSuctionCup/today`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` },
      params: { cameraId: id }
    });
  }

  getInfosCarSuctionByHour(id: string, dateStart: string, dateEnd: string): Observable<DashBoardInfos[]> {
    return this.http.get<DashBoardInfos[]>(`${environment.apiUrl}/dashboard/CarSuctionCup/hour`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` },
      params: {
        cameraId: id, from: dateStart, to: dateEnd
      },
    });
  }

  /* -------------------------------------------------------------------------- */

  /* ---------------------------------- POST ---------------------------------- */


  /* -------------------------------------------------------------------------- */


  /* ----------------------------------- PUT ---------------------------------- */


  /* -------------------------------------------------------------------------- */

}
